import React, { useContext } from "react";
import { AppContext } from "../../../AppContext";
export const actAsPremium = () => {
  const { company } = useContext(AppContext);
  let isAccessAllowed = true;
  if (company != undefined) {
    if (company.plan == "free") {
      isAccessAllowed = false;
    }
    if (company.plan == "premium") {
      isAccessAllowed = true;
    }
  }
  return [isAccessAllowed];
};
